import React, { Component } from 'react'
import PropTypes from "prop-types";
import { ReactMic } from 'react-mic';
import api from '../../utils/api';


export class Record extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: false,
            blob: {},
            loading: false,
        }

    }

    startRecording = () => {

        if(this.state.record == false) {
            this.setState({
                record: true,
                blob: {}
            });
        }
    }

    stopRecording = () => {
        this.setState({
            record: false
        });
    }

    onData = (recordedBlob) => {
        this.setState({blob: recordedBlob});
    }

    onStop = (recordedBlob) => {
        let audio = document.getElementById('recording-result');
        this.setState({blob: recordedBlob, loading: true}, () => {
            audio.pause();
            audio.load();

        });

        const data = new FormData();
        data.append('file', recordedBlob.blob, "myfile-" + new Date().getTime().toString() + ".webm");

        api.uploadAudio(data, this.props.user.id, res => {
            this.props.recordingFinished(res.data);
            this.setState({loading: false});
        })

    }

    render() {
        return (
            <div>
                {this.state.loading &&
                    <div>
                        <h5>Processing audio...</h5>
                        <div className="progress-bar-container">
                            <div className="progress-bar-circle" style={{width: this.props.uploadProgress + "%"}}></div>
                        </div>
                    </div>
                }
                <br />
                <ReactMic
                    ref={"recorder"}

                    record={this.state.record}
                    className="sound-wave"
                    onStop={this.onStop}
                    strokeColor="#ededed"
                    backgroundColor="#2d2d2d" />
                <audio id="recording-result" controls>
                    <source src={this.state.blob.blobURL} type="audio/webm" />
                </audio>
                <br />
                <div className={"col-md-12 text-center"}>
                <button className="btn btn-danger btn-round btn-lg" onClick={(this.state.record) ? this.stopRecording : this.startRecording} type="button">
                    <i className={`zmdi zmdi-${(this.state.record) ? 'stop' : 'mic'}`}></i>
                </button>
                    <br /><br />
                </div>

            </div>
        );
    }
}

export default Record;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/Record.js